enum SuperCutSegmentationType {
    Scene = 'CT_SUPER_CUT_SEGMENTATION_TYPE_SCENE',
    Caption = 'CT_SUPER_CUT_SEGMENTATION_TYPE_CAPTION',
    Experimental = 'CT_SUPER_CUT_SEGMENTATION_TYPE_EXPERIMENTAL',
}

namespace SuperCutSegmentationType {
    /**
     * Returns all segmentation types in order.
     */
    export function all(hasCaptionsFile: boolean): SuperCutSegmentationType[] {
        let segmentationTypes = [SuperCutSegmentationType.Scene, SuperCutSegmentationType.Experimental]
        if (hasCaptionsFile) {
            segmentationTypes.push(SuperCutSegmentationType.Caption)
        }
        return segmentationTypes
    }

    /**
     * Returns the segmentaion type's display title.
     */
    export function title(segmentationType: SuperCutSegmentationType): string {
        switch (segmentationType) {
            case SuperCutSegmentationType.Scene:
                return 'Scene'
            case SuperCutSegmentationType.Caption:
                return 'Caption'
            case SuperCutSegmentationType.Experimental:
                return 'Experimental'
        }
    }

    /**
     * Returns the segmentation type's description.
     */
    export function description(segmentationType: SuperCutSegmentationType): string {
        switch (segmentationType) {
            case SuperCutSegmentationType.Scene:
                return 'Segment using scene detection.'
            case SuperCutSegmentationType.Caption:
                return 'Segment using caption timestamps.'
            case SuperCutSegmentationType.Experimental:
                return 'Segment using audio detection.'
        }
    }

    /**
     * Returns the segmentation type's value to use when uploading. These are currently hardcoded in DVR.
     * TODO: Create a constants file or enum for these somewhere to ensure consistency between DVR and web-app.
     */
    export function value(segmentationType: SuperCutSegmentationType): string {
        switch (segmentationType) {
            case SuperCutSegmentationType.Scene:
                return 'SEGMENT'
            case SuperCutSegmentationType.Caption:
                return 'CAPTION'
            case SuperCutSegmentationType.Experimental:
                return 'AUDIO'
        }
    }

    export function normalize(segmentationType: string): SuperCutSegmentationType {
        switch (segmentationType) {
            case 'SEGMENT':
                return SuperCutSegmentationType.Scene
            case 'CAPTION':
                return SuperCutSegmentationType.Caption
            case 'AUDIO':
                return SuperCutSegmentationType.Experimental
            default:
                return SuperCutSegmentationType.Scene
        }
    }
}

export default SuperCutSegmentationType
